export const TIBBER_TYPE = { QUARTER: 'quarter', HOUR: 'hour' };

// slot length per price type, slots are aligned on UTC boundaries
export const TIBBER_STEP_MS = { quarter: 15 * 60 * 1000, hour: 60 * 60 * 1000 };

// Tibber selling fee per kWh, subtracted from Total when exporting
export const EXPORT_FEE = 0.0248;

// default battery round-trip efficiency (charge + discharge losses)
export const BATTERY_RTE = 0.85;

// discharge window is searched within this span after the charge window starts
export const PEAK_SEARCH_MS = 24 * 60 * 60 * 1000;

// Today tab: charge window is searched from now up to this span ahead, across midnight
export const CHARGE_SEARCH_MS = 12 * 60 * 60 * 1000;

// net gain (€/kWh) below this is shown as marginal, standby losses eat it up
export const MIN_GAIN = 0.02;

// min time between two fetch attempts for the same type + day
export const TIBBER_RETRY_MS = 60 * 1000;

export const LEVEL_COLORS = {
    VeryCheap: '#30a46c',
    Cheap: '#74c69d',
    Normal: '#6b7b8c',
    Expensive: '#f5a524',
    VeryExpensive: '#e5484d',
};

// day tabs in the widget, offset in local days from today
export const TIBBER_DAY = { TODAY: 'today', TOMORROW: 'tomorrow' };
export const TIBBER_DAY_OFFSET = { today: 0, tomorrow: 1 };
